import { Component } from '@nicolas-riciotti/light2';
import { isMobilePortrait } from '../../helpers/isMobile';
import getPosition from '../../helpers/getPosition';
import Lenis from '../../helpers/Lenis'

export default class BlockNetwork extends Component {

    created() {
        this.angle = -Math.PI/2;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this); 
        this._scroll   = 0;
    }

    resize() {
        this._width  = this.clientWidth;
        this._height = this.clientHeight;
        this.$slides.forEach((el,i) => {
            el.style.width = (window.innerWidth <= 600 ? el._mobileCardWidth : el._cardWidth ) + 'vmax'; 
            el._width  = el.clientWidth;
            el._height = el.clientHeight; 
        });
        this.$labels?.forEach((el,i) => {
            el.style.position = 'absolute';
            el.style.top = window.innerWidth <= 600 ? el._mobileTop + '%' : el._top + '%';
            el.style.left = window.innerWidth <= 600 ? el._mobileLeft + '%' : el._left + '%';
        });
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    detached() {
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
    }

    attached() {
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.$slides =this.querySelectorAll('[data-slide]');
        this.$slides.forEach((el,i) => {
            el.style.position = 'absolute';
            el.style.top      = 0;
            el.style.left     = 0;
            el._scale         = (i == 1 || i == 4 || i == 6) ? 0.8 : 1;
            el._cardWidth        = Number(el.getAttribute('data-width'))
            el._mobileCardWidth  = Number(el.getAttribute('data-mobile-width'))
        });


        this.$labels =this.querySelectorAll('[data-label]');
        this.$labels.forEach((el,i) => {
            el.style.position = 'absolute';
            el._top        = Number(el.getAttribute('data-top'))
            el._left       = Number(el.getAttribute('data-left'))
            el._mobileTop  = Number(el.getAttribute('data-mobile-top'))
            el._mobileLeft = Number(el.getAttribute('data-mobile-left'))
        });

        this.$paths        = this.querySelectorAll('path[line]');
        this.$mobilePaths  = this.querySelectorAll('path[mobile-line]');
    
        Lenis?.on?.('scroll', this.onScroll)
        this.resize();
    
    }

    onScroll(e) {
        this._scroll = e.animatedScroll ;
    }

    update() {

        if ( window.innerWidth < 600 ) {
            return;
        }

        this.offset_delta = window.innerWidth <= 600 ? 0 : 0.08;// this is hacky, we instead shoudl ch age top/left values in CMS
        const viewboxW = window.innerWidth <= 600 ? 231 : 947;
      
        const pos = getPosition(this);
 
        this.angle = (pos.top + this._scroll) / window.innerHeight * 0.3 - Math.PI*0.6; 

        if (this.stopped) {
            this.angle = - Math.PI*0.6;
        }

   

        let angleStep = (Math.PI * 2) / this.$slides.length;
        let maxW = 0;
        let maxH = 0;
        this.$slides.forEach((el,i) => {
            maxH = Math.max(el._height, maxH);
        });

        const containerPos = getPosition(this);

        this.$slides.forEach((el,i) => {

            if (window.innerWidth <= 600) {
                const x = this._width/2  + Math.cos(i * angleStep + this.angle) * (this._width/2) - el._width/2;
                const y = this._height/2 + Math.sin(i * angleStep + this.angle) * (this._height/2) - el._height/2;
                el.style.transform = `translate(${x}px, ${y}px) scale(${el._scale}) translateZ(0)`;
                const r = viewboxW / this._width
                const d = this.$mobilePaths[i].getAttribute('_d');
                this.$mobilePaths[i].setAttribute('d', d.replace('{{x}}',(x + el._width/2) *r ).replace('{{y}}',(y + el._height/2 + (this.clientHeight * -this.offset_delta)) * r ) );
            }
            else {
                const x = this._width/2  - el._width/2 + Math.cos(i * angleStep + this.angle) * (this._width/2 - maxW/2) ;
                const y = this._height/2 - el._height/2 + Math.sin(i * angleStep + this.angle) * (this._height/2- maxH/2) ;
                el.style.transform = `translate(${x}px, ${y}px) scale(${el._scale}) translateZ(0)`;
                const r = viewboxW / this._width
                const d = this.$paths[i].getAttribute('_d');
                this.$paths[i].setAttribute('d', d.replace('{{x}}',(x + el._width/2) *r ).replace('{{y}}',(y + (this.clientHeight * -this.offset_delta)) * r ) );
            }

        });
    }
}

customElements.define('block-network', BlockNetwork);
